import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs/';
import { environment } from 'src/environments/environment';
import { Lottery } from '../../models/offer.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalInformationComponent } from 'src/app/components/modal-information/modal-information.component';

const randN: number = Math.floor(Math.random() * (5000 - 1)) + 1;
const lottosSource: string = `https://rapi-reports-prod-public.s3.eu-central-1.amazonaws.com/reports/board.json?ran=${randN}`;
const rapiURL: string = environment.rapi;

@Injectable({
  providedIn: 'root'
})
export class LottosService {
  lottery: Lottery;

  public lottoObj: any = {};
  private lottosArrSubject = new ReplaySubject(5);
  public lottoObservable$ = this.lottosArrSubject.asObservable();

  private lottoPriceSubject = new ReplaySubject<any>(5);
  lottoPrice$: Observable<any> = this.lottoPriceSubject.asObservable();

  constructor(protected _http: HttpClient, public dialog: MatDialog) {
    this.setLotteryValue();
    this.lottoPrice$ = this.lottoPriceSubject.asObservable();
    this.bringLottos();
  }

  setLotteryValue(): void {
    let landing: any = environment;
    this.lottery = landing.hasOwnProperty('lottery') ? landing.lottery : null;
  }

  getLottos() {
    return this._http.get(lottosSource);
  }

  getLottoss(lotto: any, system: string, product: string) {
    this._http.get(`${rapiURL}/api/lotteries/${lotto}`).subscribe(
      (response: any) => {
        let { data } = response;
        if (data.identifier == lotto) {
          this.lottoObj.id = data.identifier;
          this.lottoObj.name = data.name;
          this.lottoObj.country = data.region.name;
          this.lottoObj.jackpot = this.formatJackpot(data);
          this.lottoObj.currency = data.currency;
          this.lottoObj.draw = this.formatDrawDate(data);
          this.lottoObj.system = system;
          this.lottoObj.product = product;
          this.setSubject(this.lottoObj);
        }
      },
      (error: any) => {
        this.openModalInformation();
      }
    );
  }

  private formatJackpot(response): number {
    let jackpot: any = response.jackpot;
    if (this.lottery && this.lottery.lot_id === 11 && this.lottery.special_draw && response.special_draw) {
      jackpot = response.special_draw.jackpot;
    } else if (this.lottery && this.lottery.lot_id === 38) {
      if (response.active_draw && response.active_draw.jackpot_modifiers) {
        if (response.active_draw.jackpot_modifiers.length > 0) {
          if (response.active_draw.jackpot_modifiers[0]) {
            jackpot = jackpot + response.active_draw.jackpot_modifiers[0]?.jackpot;
          }
          if (response.active_draw.jackpot_modifiers[1]) {
            jackpot = jackpot + response.active_draw.jackpot_modifiers[1]?.jackpot;
          }
        }
      }
    }
    if (jackpot > 999999) {
      let result = (parseFloat(jackpot.toLocaleString('en-US').replace(',', '.')) * 1).toString().split('.');
      if (jackpot.toString().length >= 10) {
        result = jackpot.toLocaleString('en-US').replace(',', '.').split(',');
      }
      if (result.length === 1) {
        return Number(result[0]);
      } else if (result.length > 0) {
        return Number(result[0].replace('.', '') + (result[1].length > 1 ? '' : '.' + result[1]));
      }
    }else{
      return jackpot
    }
  }

  private formatDrawDate(response): string {
    let drawDate: any = response.draw_date;
    if (this.lottery && this.lottery.lot_id === 11 && this.lottery.special_draw && response.special_draw)
      drawDate = `${response.special_draw.date} ${response.special_draw.time}`;
    return drawDate;
  }

  setSubject(n: any): void {
    this.lottosArrSubject.next(n);
  }

  setLottoPriceSubject(lottoPrice: any): void {
    this.lottoPriceSubject.next(lottoPrice);
  }

  getLotteryPrice(lotto: number): Observable<any> {
    return this._http.get(`${rapiURL}/api/lotteries/prices_list/${lotto}`);
  }

  protected bringLottos(): void {
    if (this.lottery.lot_id !== 0) {
      this.getLotteryPrice(this.lottery.lot_id).subscribe((res: any) => {
        res.data.map((dataRow) => {
          if (dataRow.draws == 1) {
            this.setLottoPriceSubject(dataRow);
          }
        });
      });
    }
  }

  openModalInformation(): void {
    this.dialog.open(ModalInformationComponent, {
      disableClose: true,
      width: '450px',
      data: { id: 1 }
    });
  }
}
